module.exports = __webpack_public_path__ + "static/img/sec1-cont-pc@w.d525213.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec1-cont-pc@w.png
// module id = 9id9
// module chunks = 0